<template>
  <div v-if="page_loading">
    <loading :page_loading="page_loading" />
  </div>
  <div v-else class="mt-0" align="center">
    <!-- page 1 -->
    <div  v-for="(item) in dataPrint" :key="item.id" >
      <v-card :elevation="0" width="793" v-if="dataPrint_Count > 0">
        <v-card-text>
          <v-row class="py-3">
            <v-col class="py-1 px-0" cols="8">
              <v-row>
                {{ check_logo(item.branchLogo) }}
                <v-col class="py-1 px-0" v-if="branchLogo != null" :cols="cols1" >
                  <v-img
                      :src="branchLogo"
                      aspect-ratio="1"
                      class="grey lighten-2"
                      max-width="50"
                      max-height="50"
                  ></v-img>
                </v-col>
                <v-col class="py-1 px-0" :cols="cols2" >
                  <v-row>
                    <v-col cols="12" align="left" class="font-weight-bold py-1 px-0">{{ item.branchName }}</v-col>
                  </v-row>
                  <v-row>
                    <v-col class="py-1 px-0" cols="12" align="left" >{{ item.branchAddress + ' ' + item.branchSubDistrict + ' ' + item.branchDistrict + ' ' + item.branchProvince + ' ' + item.branchPostcode}}</v-col>
                  </v-row>
                  <v-row>
                    <v-col class="py-1 px-0" cols="12" align="left">{{use_language.tax_invoice_number}} {{ item.branchTaxID }}</v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
            <v-col class="py-1 px-0" cols="4">
              <v-row>
                <v-col cols="12" align="right" class="font-weight-bold py-1 px-0">
                  <h3 v-if="print_type == 1">{{use_language.invoice_}}</h3>
                  <h3 v-else>{{use_language.receipt_tax_invoice}}</h3>
                  <!-- <span v-if="item.header1 == null"> <h3>ใบแจ้งหนี้ / ใบกำกับภาษี</h3> </span>
                  <span v-else>{{ item.header1 }} {{ item.header2 == null ? "" : " / " + item.header2 }}  </span> -->
                </v-col>
              </v-row>
              <v-row>
                <v-col class="py-1 px-0" cols="12" align="left" ></v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-row class="py-3">
            <v-col class="py-1 px-0" cols="8">
              <v-row>
                <v-col cols="3" align="left" class="font-weight-bold py-1 px-0">{{use_language.customer_name}} : </v-col>
                <v-col class="py-1 px-0" cols="9" align="left" >{{ item.customerName }}</v-col>
              </v-row>
              <v-row>
                <v-col cols="3" align="left" class="font-weight-bold py-1 px-0">{{use_language.address}} : </v-col>
                <v-col class="py-1 px-0" cols="9" align="left" >{{ item.customerAddress + ' ' + item.customerSubDistrict + ' ' + item.customerDistrict + ' ' + item.customerProvince + ' ' + item.customerPostcode}}</v-col>
              </v-row>
              <v-row>
                <v-col cols="3" align="left" class="font-weight-bold py-1 px-0">{{use_language.tax_invoice_number}} : </v-col>
                <v-col class="py-1 px-0" cols="9" align="left" >
                  <span v-if="item.customerTaxID != null">{{ item.customerTaxID }}</span>
                  <span v-else>-</span>
                </v-col>
              </v-row>
            </v-col>
            <v-col class="py-1 px-0" cols="4">
              <v-row>
                <v-col cols="5" align="left" class="font-weight-bold py-1 px-0">{{use_language.no_2}} : </v-col>
                <v-col class="py-1 px-0" cols="7" align="left">
                  <span v-if="print_type == 1">{{ item.invoiceNo }} </span>
                  <span v-else>{{ item.invoiceNo.replace('INV', 'RC') }}</span>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="5" align="left" class="font-weight-bold py-1 px-0">{{use_language.date}} : </v-col>
                <v-col class="py-1 px-0" cols="7" align="left">
                  {{ item.invoiceDate }}
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <div class="py-3">
            <table width="100%" border="0" style="border-collapse: collapse;">
              <tr class="border-a">
                <th align="center" class="py-2 border-right">
                  {{use_language.number}}<br>
                  {{use_language.number_}}
                </th>
                <th width="55%" align="center" class="py-2 border-right">
                  {{use_language.list}}<br>
                  {{use_language.order_1}}
                </th>
                <th width="15%" align="center" class="py-2 border-right">
                  {{use_language.quantity}}<br>
                  {{use_language.quantity_1}}
                </th>
                <th width="15%" align="center" class="py-2 border-right">
                  {{use_language.unit_price}} <br>
                  {{use_language.Unit_Price}}
                </th>
                <th width="15%" align="center" class="py-2 border-right">
                  {{use_language.amount}} <br>
                  {{use_language.amount_1}}
                </th>
              </tr>
              <tr  Valign="top" v-for="(item2) in item.itemList" :key="item2.id">
                <td align="center" class="px-2 border-x">{{ item.itemList.indexOf(item2) + 1 }}</td>
                <td align="left" class="px-2 border-right">{{item2.description}}</td>
                <td align="right" class="px-2 border-right">{{ item2.quantity }}</td>
                <td align="right" class="px-2 border-right">{{ formatMoney(item2.unitPrice.toFixed(2)) }}</td>
                <td align="right" class="px-2 border-right">{{ formatMoney((item2.quantity*item2.unitPrice).toFixed(2)) }}</td>
              </tr>
              <tr :height="calendar_last_row_height(item.itemList.length)"  Valign="top" class="border-bottom">
                <td align="left" class="px-2 border-x"></td>
                <td align="left" class="px-2 border-right"></td>
                <td align="right" class="px-2 border-right"></td>
                <td align="right" class="px-2 border-right"></td>
                <td align="right" class="px-2 border-right"></td>
              </tr>
              <tr Valign="top" class="border-bottom">
                <td align="left" class="px-2 py-2 border-a" colspan="2">
                  <span class="font-weight-bold">{{use_language.note_remark}}</span><br>
                  <span v-if="item.discount < 0">{{use_language.have_a_discount}}  {{ item.discount }} {{use_language.bath}}</span>
                  <span v-else>-</span>
                </td>
                <td align="left" colspan="2" class="px-2 py-2 border-a">
                  <v-row>
                    <v-col cols="12" align="left" class="font-weight-bold py-1 px-0">{{use_language.total}}</v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" align="left" class="font-weight-bold py-1 px-0">{{use_language.amount_calculated_for_tax}}</v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" align="left" class="font-weight-bold py-1 px-0">{{use_language.vat}}
                      <span v-if="item.vatType == 1">(No VAT)</span>
                      <span v-if="item.vatType == 2">(VAT Included)</span>
                      <span v-if="item.vatType == 3">(VAT Excluded)</span>
                    </v-col>
                  </v-row>
                  <!-- <v-row>
                    <v-col cols="12" align="left" class="font-weight-bold py-1 px-0">ส่วนลด</v-col>
                  </v-row> -->
                  <v-row>
                    <v-col cols="12" align="left" class="font-weight-bold py-1 px-0">{{use_language.grand_total}}</v-col>
                  </v-row>
                </td>
                <td align="left" class="px-2 py-2 border-a">
                  <v-row>
                    <v-col class="py-1 px-0" cols="12" align="right"><span v-if="item.totalItemPrice!= null">{{ item.totalItemPrice }}</span> <span v-else>0</span></v-col>
                  </v-row>
                  <v-row>
                    <v-col class="py-1 px-0" cols="12" align="right"> <span v-if="item.calculatedPrice!= null">{{ item.calculatedPrice }}</span> <span v-else>0</span> </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="py-1 px-0" cols="12" align="right"><span v-if="item.vatAmount!= null">{{ item.vatAmount }}</span> <span v-else>0</span></v-col>
                  </v-row>
                  <!-- <v-row>
                    <v-col class="py-1 px-0" cols="12" align="right"><span v-if="item.discount!= null">{{ item.discount }}</span> <span v-else>0</span></v-col>
                  </v-row> -->
                  <v-row>
                    <v-col class="py-1 px-0" cols="12" align="right"><span v-if="item.totalPrice!= null">{{ item.totalPrice }}</span> <span v-else>0</span></v-col>
                  </v-row>
                </td>
              </tr>
            </table>
          </div>

        </v-card-text>
      </v-card>
      <!-- page 2 -->
      <div style="break-after:page"></div>
    </div>


  </div>
</template>
<script>
import Loading from '@/website/components/Loading'
import axios from 'axios'
import Swal from 'sweetalert2'
import { reportService_dotnet } from '@/website/global'
import { DateNow, FormatInvoice, formatMoney, set_format_date_time,get_languages } from '@/website/global_function'
// import THBText from 'thai-baht-text'
import { header_token } from '@/website/backend/token'
// import VueBarcode from 'vue-barcode'
// import VueQrcode from 'vue-qrcode'


  export default {
    components: {
      Loading
    },
    data: () => ({
      page_loading: true,
      loading: false,

      use_language: null,
      set_language: null,

      dataPrint_Count: 0,
      dataPrint: [],
      dataList: [],

      show_page1: true,
      show_page2: true,
      show_page3: true,

      branchLogo: null,
      cols1 : 2,
      cols2 : 10,
      IsHaveInvoice : false,
    }),
    async created () {


       //เก็บภาษามาไว้ใน use_language
         this.use_language = await this.get_languages(localStorage.getItem("set_language"));




      this.inv_id = null
      this.groupID = null
      if(this.$route.query.inv === 'undefined'){
        this.inv_id = null
      } else if ( this.$route.query.inv == 'null') {
        this.inv_id = null
      } else if ( this.$route.query.inv == null) {
        this.inv_id = null
      } else if (this.$route.query.inv == '') {
        this.inv_id = null
      } else {
        this.inv_id = this.$route.query.inv
      }

      if(this.$route.query.group === 'undefined'){
        this.groupID = null
      } else if ( this.$route.query.group == 'null') {
        this.groupID = null
      } else if ( this.$route.query.group == null) {
        this.groupID = null
      } else if (this.$route.query.group == '') {
        this.groupID = null
      } else {
        this.groupID = this.$route.query.group
      }

      if(this.$route.query.inv === 'undefined'){
        this.groupName = null
      } else if ( this.$route.query.inv == 'null') {
        this.groupName = null
      } else if ( this.$route.query.inv == null) {
        this.groupName = null
      } else if (this.$route.query.inv == '') {
        this.groupName = null
      } else {
        this.groupName = this.$route.query.groupname
      }

      if(this.groupID != null){
        this.inv_id = null
      }


      this.print_type = this.$route.query.type
      await this.get_data_print(this.inv_id, this.groupID, this.groupName)
      this.page_loading = false

      setTimeout(function(){
        if(this.IsHaveInvoice){
          print()
        }
       }, 500);


      if(this.inv_id == null && this.groupID == null){
        window.close();
      }



    },
    watch: {
    },
    computed: {
      headers () {
        if(this.use_language == null) return []
        return [
          { text: this.use_language.menu_orders, align: 'center', value: 'ID', sortable: false },
          { text: this.use_language.track_number, align: 'center', value: 'TrackingNo', sortable: false },
          { text: this.use_language.delivery_fee, align: 'right', value: 'DeliveryPrice', sortable: false },
          { text: this.use_language.remote_area_fee, align: 'right', value: 'RemotePrice', sortable: false },
          { text: this.use_language.cod_value, align: 'right', value: 'CODCharged', sortable: false },
          { text: this.use_language.box_fee, align: 'right', value: 'BoxPrice', sortable: false },
          { text: this.use_language.pack_fee, align: 'right', value: 'PackPrice', sortable: false },
          { text: this.use_language.discount, value: 'Discount', sortable: false, align: 'right' },
          { text: this.use_language.total_price, align: 'right', value: 'TotalPrice', sortable: false },
        ]
      },
    },
    methods: {
      // DateNow,
      FormatInvoice,
      formatMoney,
      get_languages,  
      
      calendar_last_row_height (row_len) {
        if(row_len > 0){
          var max_height = 510
          var row_data = row_len
          var fix_height = 19.44
          var res =  (fix_height*row_data)
          return max_height - res
        } else {
          return 630
        }
      },

      async get_data_print(invoiceID, invoiceGroupID, groupName){
        this.loading = true
        let res1 = await axios.post(reportService_dotnet+'Invoice/invoice-print', {
           "invoiceID":  invoiceID,
           "invoiceGroupID":  invoiceGroupID,
           "groupName": groupName
        },
        { headers: header_token})
        if(res1.data.invoiceList == null){
            res1.data.invoiceList = []
        }

        if(res1.data.invoiceList.length > 0){
          this.dataPrint = res1.data.invoiceList
          this.dataPrint_Count = res1.data.invoiceList.length
          this.IsHaveInvoice = true
          this.loading = false

        } else {
          this.$swal({
            type: 'warning',
            title: this.use_language.invoice_not_found,
          })
          this.IsHaveInvoice = false
          this.loading = false
        }


      },

      check_logo (branch_logo) {
        // branch_logo = 'https://packhaistorage.s3-ap-southeast-1.amazonaws.com/image/dhl.PNG'
        if(branch_logo == null){
          this.branchLogo = branch_logo
          this.cols2 = 12
        } else {
          this.branchLogo = branch_logo
          this.cols1 = 2
          this.cols2 = 10
        }
      },
    },
  }
</script>
<style scoped>

    >>>.set-font-size thead tr th{

      font-weight: bold !important;
      font-size: 11px !important;
    }

    /* border table */

    >>>.border-left{
      border-left: 1px solid black !important;
    }
    >>>.border-right{
      border-right: 1px solid black !important;
    }
    >>>.border-top{
      border-top: 1px solid black !important;
    }
    >>>.border-bottom{
      border-bottom: 1px solid black !important;
    }
    >>>.border-x{
      border-left: 1px solid black !important;
      border-right: 1px solid black !important;
    }
    >>>.border-y{
      border-top: 1px solid black !important;
      border-bottom: 1px solid black !important;
    }
    >>>.border-a{
      border: 1px solid black !important;
    }
</style>
